import { useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { Box } from "@mui/material"
import { useAppSelector, useAppDispatch } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"
import FormControlLabel from "@mui/material/FormControlLabel"
import Checkbox from "@mui/material/Checkbox"
import Radio from "@mui/material/Radio"
import RadioGroup from "@mui/material/RadioGroup"
import FormControl from "@mui/material/FormControl"
import FormLabel from "@mui/material/FormLabel"
import { UTextField } from "@/components/index"
import { UButton } from "@/components/index"
export const OrderLabel = () => {
  const {
    clinicalSettings: { LabelLocation },
  } = useAppSelector((state: RootState) => state.userService)
  const dispatch = useAppDispatch()
  // checkbox if No label
  const [checkNoLabel, setCheckNoLabel] = useState<boolean>(false)
  const handleCheck = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCheckNoLabel(event.target.checked)
  }
  // select position
  const [toothPosition, setToothPosition] = useState<string>("")
  const handleToothPosition = (event: React.ChangeEvent<HTMLInputElement>) => {
    setToothPosition((event.target as HTMLInputElement).value)
  }
  // init tabs value
  useEffect(() => {
    if (LabelLocation === "NoCaseNumber") {
      setCheckNoLabel(true)
    }
    if (LabelLocation !== "") {
      setToothPosition(LabelLocation)
    }
  }, [])
  return (
    <Box sx={{ width: "100%" }}>
      <FormControlLabel
        control={<Checkbox checked={checkNoLabel} onChange={handleCheck} />}
        label="No label on the model"
        sx={{ margin: "0 0 10px 0" }}
      />
      <Box sx={{ width: "100%", display: "flex" }}>
        <FormControl sx={{ marginRight: "240px" }} disabled={checkNoLabel}>
          <FormLabel id="toothPosition">{`Select the position to place label`}</FormLabel>
          <RadioGroup
            sx={{ marginLeft: "10px" }}
            aria-labelledby="toothPosition"
            name="radio-buttons-group"
            value={toothPosition}
            onChange={handleToothPosition}
          >
            <FormControlLabel
              value="Bottom"
              control={<Radio />}
              label="Bottom"
            />
            <FormControlLabel
              value="WallLingual"
              control={<Radio />}
              label="Lingual wall"
            />
            <FormControlLabel
              value="Wall"
              control={<Radio />}
              label="Buccal wall"
            />
          </RadioGroup>
        </FormControl>
        <FormControl disabled={checkNoLabel}>
          <FormLabel id="sideNumber">{` Custom label (up to 10 characters)`}</FormLabel>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <UTextField sxProp={{ width: "300px" }} disabled={checkNoLabel} />
            <UButton
              sxProp={{
                marginLeft: "10px",
                color: "#212121",
                height: "36px",
                borderRadius: "4px",
                background: "#DADCDD !important",
                boxShadow:
                  "0px 1px 5px 0px rgba(0, 0, 0, 0.12), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.20)",
                padding: "6px 16px",
              }}
              variant={"contained"}
              btnText={`APPLY`}
              disabled={checkNoLabel}
            />
          </Box>
          <UButton
            sxProp={{
              marginTop: "80px",
              color: "#212121",
              height: "36px",
              width: "138px",
              borderRadius: "4px",
              background: "#DADCDD !important",
              boxShadow:
                "0px 1px 5px 0px rgba(0, 0, 0, 0.12), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.20)",
              padding: "6px 16px",
            }}
            variant={"contained"}
            btnText={`Label Preview`}
          />
        </FormControl>
      </Box>
    </Box>
  )
}
